import { useEffect, useState } from "react";
import { api, errorMessage } from "@/lib/api";
import ThreadList, { type ThreadFilter, type ThreadItem } from "@/components/student/ThreadList";

const FILTERS: ThreadFilter[] = [
  { id: "all", label: "All", test: () => true },
  { id: "mine", label: "Where I commented", test: (item) => item.viewerPosted },
  { id: "feedback", label: "Teacher feedback", test: (item) => item.teacherFeedback },
];

export default function StudentThreads() {
  const [items, setItems] = useState<ThreadItem[] | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancel = false;
    api<{ success: boolean; data: ThreadItem[] }>("/api/student/threads")
      .then((env) => {
        if (!cancel) setItems(env.data || []);
      })
      .catch((err) => {
        if (!cancel) setError(errorMessage(err));
      });
    return () => {
      cancel = true;
    };
  }, []);

  return (
    <div className="student-page">
      <div className="student-page-head">
        <span className="student-eyebrow">Feedback</span>
        <h1>Your conversations</h1>
        <p>Recent places you have commented, and feedback from your teachers.</p>
      </div>
      {error ? (
        <div className="student-inline-error" role="alert">
          {error}
        </div>
      ) : !items ? (
        <div aria-busy="true">
          <span className="student-vh">Loading your threads</span>
        </div>
      ) : (
        <ThreadList
          items={items}
          filters={FILTERS}
          hrefFor={(item) => `/student/activity/${encodeURIComponent(item.activityId)}?chat=1`}
          emptyTitle="No conversations yet"
          emptyText="When you message a teacher or get feedback on your work, it shows up here."
        />
      )}
    </div>
  );
}
